<template>
  <div class="animated fadeIn">        
    <b-card v-if="(showForm==false)">
        <div slot="header">
            Mapping COA Unit vs Consolidate
            <div class="card-header-actions">
            <b-button variant="btn btn-primary mr-1" @click="add">Add</b-button>
            <b-button variant="primary mr-1" @click="showUploadFrm=true"><i class="fa fa-cloud-upload"></i> Import/Upload</b-button>
            <b-button variant="btn btn-primary mr-1" @click="exportxls">Export</b-button>
            <b-button variant="btn btn-primary" @click="close">Close</b-button>
                <button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
            </div>
        </div>
        <b-row >
            <b-col lg="5">
            <b-input-group>
                <b-input-group-prepend>
                <span class="pt-2 pr-2">Unit Bisnis</span>
                </b-input-group-prepend>
                <!-- <b-form-select v-model="frmdata.compcode" :plain="true" :options="companies"></b-form-select> -->
                  <b-form-input readonly v-model="frmdata.company" ></b-form-input>
                  <b-input-group-append>
                  <b-btn text="Button" @click="lkuCompanyShow=true" >
                      <i class="fa fa-search"></i>
                  </b-btn>
                  </b-input-group-append>

                <b-button class="btn btn-success ml-2" @click="getData()" > <i class="fa fa-play"></i> Open</b-button>

            </b-input-group>
            </b-col>
            <b-col lg="4">
                <b-input-group size="sm" v-if="(filterShow=='Hide')">
                    <b-form-checkbox v-model="filterShow" value="Hide" unchecked-value="Show" switch class="pt-1"></b-form-checkbox>
                    <b-input-group-prepend> <span class="pt-1 pr-2">
                        <b> {{ filterShow }}</b>  Filter </span>
                    </b-input-group-prepend>
                    <b-form-input v-model="filter" type="search" placeholder="Type to Search"></b-form-input>
                    <b-input-group-append>
                        <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                    </b-input-group-append>
                </b-input-group >
                <b-input-group size="sm" v-else>
                <b-form-checkbox v-model="filterShow" value="Hide" unchecked-value="Show" switch class="pt-1">
                </b-form-checkbox>
                    <b-input-group-prepend> <span class="pt-1 pr-2">
                        <b> {{ filterShow }}</b>  Filter </span>
                    </b-input-group-prepend>
                </b-input-group>
            </b-col>
        </b-row>
        <b-table
            class="mb-0"
            ref="table"
            outlined
            responsive striped hover
            style="font-size:smaller;" 
            :items="tblData.items"
            :fields="tblData.fields"
            :current-page="tblData.page"
            :per-page="tblData.limit"
            :sort-by.sync="tblData.sortBy"
            :sort-desc.sync="tblData.sortDesc"
                :filter="filter"
                :filterIncludedFields="filterOn"
                @filtered="onFiltered"                
        >
            <template v-slot:thead-top="data">
                <b-tr>
                    <b-th variant="primary" colspan="2" class="text-center">UNIT ACCOUNT</b-th>
                    <b-th variant="success" colspan="3" class="text-center">CONSOLIDATION ACCOUNT</b-th>
                </b-tr>
            </template>
            <template v-slot:cell(action)="data">
              <div class="text-center">
              <a href="javascript:void(0)" class="text-danger" @click="deleteConfirm(data.item)">
                <i class="fa fa-trash"></i>
              </a>
              </div>
            </template>
        </b-table>
        <b-row class="mt-2">
            <b-col cols="4">
            <div>
                Showing {{(tblData.page - 1) * tblData.limit + 1}}
                to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
                of {{tblData.total}} entries
            </div>
            </b-col>
            <b-col cols="4" >
                <b-form-group label-cols=3 label="Limit per page" class="mb-0">
                <b-form-select :options="[10, 20, 30, 50, 70, 90, 120]" :plain="true" v-model="tblData.limit"  style="width:80px;"/>
                </b-form-group>
            </b-col>        
            <b-col cols="4">            
            <b-pagination
                align="right"
                :total-rows="tblData.total"
                :per-page="tblData.limit"
                v-model="tblData.page"
            ></b-pagination>
            </b-col>
        </b-row>
    </b-card>
    <b-row class="justify-content-center" v-if="(showForm==true)">
      <b-col md="8" lg="6">
            <b-card >
            <div slot="header">Mapping Account - Add/Edit Form 
                <div class="card-header-actions">
                <button class="btn btn-primary mr-1" @click="save()">
                    <i class="fa fa-save"></i> Save
                </button>
                <b-button class="btn btn-primary mr-1" @click="closeFrm()" > <i class="fa fa-close"></i> Close Form</b-button>
                </div>
            </div>
              <b-input-group >
                <b-input-group-prepend><label>Unit Bisnis</label></b-input-group-prepend>
                <!-- <b-form-select v-model="frmdata.compcode" :plain="true" :options="companies"></b-form-select> -->
                  <b-form-input readonly v-model="frmdata.company" ></b-form-input>
                  <b-input-group-append>
                  <b-btn text="Button" @click="lkuCompanyShow=true" >
                      <i class="fa fa-search"></i>
                  </b-btn>
                  </b-input-group-append>
              </b-input-group>
              <b-input-group >
                <b-input-group-prepend><label>Unit Account</label></b-input-group-prepend>
                  <b-form-input  v-model="frmdata.kodeacc" placeholder="Account Code"></b-form-input>
                  <b-form-input v-model="frmdata.namaacc" class="ml-1" placeholder="Account Name" style="width:40% !important;" ></b-form-input>
              </b-input-group>
              <b-input-group >
                  <b-input-group-prepend><label>Consolidation Acc.</label></b-input-group-prepend>
                  <b-form-input readonly v-model="frmdata.consolaccInfo" ></b-form-input>
                  <b-input-group-append>
                  <b-btn text="Button" @click="showLkuCoa('consolacc')" >
                      <i class="fa fa-search"></i>
                  </b-btn>
                  </b-input-group-append>
              </b-input-group>
            </b-card>
          </b-col>
    </b-row>

    <b-modal v-model="showUploadFrm" size="lg" title="Import/Upload Mapping Account" @ok="uploadmapping">
          <b-input-group>
            <b-input-group-prepend>
              <span class="pt-2 pr-2">Unit Bisnis</span>
            </b-input-group-prepend>
                  <b-form-input readonly v-model="frmdata.company" ></b-form-input>
                  <b-input-group-append>
                  <b-btn text="Button" @click="lkuCompanyShow=true" >
                      <i class="fa fa-search"></i>
                  </b-btn>
                  </b-input-group-append>
          </b-input-group>
      <b-input-group>
        <b-input-group-prepend>
          <label >Choose *.XLSX file</label>
        </b-input-group-prepend>
        <b-form-file
          v-model="fileXlsx"
          :state="Boolean(fileXlsx)"
          placeholder="Choose a XLSX file..."
          drop-placeholder="Drop XLSX file here..."
        ></b-form-file>
      </b-input-group>
      <div style="display:blocked; text-align:right;">
        <b-link @click="downloadtemplate"><i class="fa fa-paperclip"></i> EkosSystem-Mapping-upload-template.xlsx</b-link>
      </div>      
      <p  class="font-weight-bold m-0 text-danger"> Important:  &nbsp;&nbsp;  Header Account tidak perlu dimapping </p>
    </b-modal>

        <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
        <p class="mb-1">1 record is about to be permanently deleted</p>
        <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p>
        </b-modal>

        <b-modal v-model="lkuCoaShow" size="lg" :hide-footer="true" title="Consolidation Account" :centered="true">
            <lku-coa @click="onSelectLkuCoa" :tahun="tahun" :key="tahun"></lku-coa>
        </b-modal>        
        <b-modal v-model="lkuCompanyShow" size="lg"  :hide-footer="true" title="Consolidation Company" :centered="true">
            <lku-company @click="onSelectLkuCompany"></lku-company>
        </b-modal>        
        <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       

    </div>
</template>
<style lang="scss">
    .input-group {
        padding-bottom:2px;
        .input-group-prepend {
            label {
                padding-top: 5px;
                width: 160px !important;
            }
        }
    }

</style>

<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import toastr from "mini-toastr";
import lkuCoa from "../lookup/lkuConsolidaCoa";
import lkuCompany from "../lookup/lkuConsolidaCompany"
import mapcoa from "../../apis/consolidacoa";
import { validationMixin } from "vuelidate";
import { required} from "vuelidate/lib/validators";
toastr.init();

export default {   
  components: { Loading, lkuCoa, lkuCompany},
  mixins: [validationMixin],
  validations: {
        frmdata: {
            compcode: { required },
        }
  }, 
  data() {
    return {
      showDelConfirm:false,
      showUploadFrm: false,
      fileXlsx: null,
      model:{},
      tblData: {
        items: [],
        fields: [
                {
                    key: "kodeacc",
                    label: "Account Code",
                    thStyle: "width:200px",
                    sortable: true
                },
                {
                    key: "namaacc",
                    label: "Unit Account Name",
                },
                {
                    key: "consolacc",
                    label: "Account Code",
                    thStyle: "width:200px",
                    sortable: true
                },
                {
                    key: "consolaccname",
                    label: "Consolidation Account Name",
                },
                {
                    key: "typeacc",
                    thStyle: "width:100px",
                    label: "Account Type"
                },
                {
                    key: "action",
                    label: "Action",
                    thStyle: "width:50px",
                    thClass: "text-center",
                },

            ],
            page: 1,
            limit: 15,
            total: 0,
            
            sortBy: null,
            sortDesc: false,
            kodeacc: "",
            namaacc: "",
            tahun: new Date().getFullYear(),
            tahunBukuFrm :[]
        },
        companies:[],  
        showForm:false,  
        frmdata:{compcode:''},  
        filter: null,
        filterOn:null,
        filterShow: 'Show',
        saveEnabled:true,isLoading:false,

        lkuCoaShow:false,
        lkuCoaCaller:'adv',
        tahun:(this.$store.state.user.tglaktifconsol || '').substring(0,4),
        lkuCompanyShow:false
    };
},
  computed: {
    invalidModel() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },
    invalidFrmdata() {
      this.$v.frmdata.$touch();
      return this.$v.frmdata.$invalid;
    },
  },
//   watch: {
//     "frmdata.compcode": function(newVal) {
//       const company = this.companies.find(c => c.compcode==newVal);
//       if (company) {
//          this.frmdata.company=company.text;
//       }
//     }
//   },
  created: async function() {
    this.companies= await mapcoa.companies();
        // this.companies.forEach((kol, idx) => {
        //     kol.namakolom = `K${kol.value.replace(/ /g, '').replace('-','')}`;
        //     if (!(kol.compcolor)) {
        //         kol.compcolor= '#'+this.getRandomColor();
        //     }
        // });  
  },
  methods: {
    onFiltered(filteredItems) {
      this.tblData.total = filteredItems.length;
    },
    showLkuCoa(callerObj)
    {
      this.lkuCoaShow=true;
      this.lkuCoaCaller=callerObj;
    },
    onSelectLkuCoa(_selected) {
            this.frmdata[`${this.lkuCoaCaller}Info`] = _selected.kodeacc.trim() + ' | ' + _selected.namaacc.trim();
            this.frmdata[`${this.lkuCoaCaller}`] = _selected.kodeacc;
            this.frmdata[`${this.lkuCoaCaller}name`] = _selected.namaacc;
        this.lkuCoaShow=false;
    },
    onSelectLkuCompany: async function (_selected) {
            this.frmdata.compcode= _selected.compcode;
            this.frmdata.company= _selected.company;
          this.lkuCompanyShow=false;
    },  
    getData: async function(ctx) {
      if (this.invalidFrmdata) {
            toastr.error('Please fill the form correctly.');
       } else {
        try {
          this.isLoading=true;
          this.tblData.items = await mapcoa.getmapping(this.frmdata);
        //   console.log('this.tblData.items: ', this.tblData.items);
          if (this.tblData.items) {
              this.tblData.total = this.tblData.items.length;  
          }
          this.isLoading=false;    
          } catch (error) {
                  this.isLoading=false;
              console.log('error : ', error);
              if (error.sql) {
                  toastr.error(error.sql,'ERROR MESSAGE',10000);
              } else if (error.sqlMessage) {
                  toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
              } else if (error.message) {
                  toastr.error(error.message,'ERROR MESSAGE',10000);
              } else {
                  toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
              }   
              this.isLoading=false;            
          }

       }
    },   
    deleteConfirm(item) {
      this.model = item;
      this.showDelConfirm = true;
    },
    deleteData: async function() {
      try {
          await mapcoa.delmapping(this.model);
          this.getData();
      } catch (error) {
          console.log('error : ', error);
          if (error.sql) {
              toastr.error(error.sql,'ERROR MESSAGE',10000);
          } else if (error.sqlMessage) {
              toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
          } else if (error.message) {
              toastr.error(error.message,'ERROR MESSAGE',10000);
          } else {
              toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
          }        
      }

    },

    add: function(){
        this.frmdata.kodeacc=''; 
        this.frmdata.namaacc=''; 
        this.showForm=true;
    } , 
    save: async function () {
        this.saveEnabled=false;
        if (this.invalidFrmdata) {
            console.log('validation : ', this.$v.frmdata);
            console.log('frmdata obj : ',this.frmdata);
            toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
            this.saveEnabled=true;
        } else {
            try {
                    this.isLoading=true;            
              const data = {};
                data.company  =  	 this.frmdata.company ; 
                data.compcode  =  	 this.frmdata.compcode; 
                data.kodeacc  =  	 this.frmdata.kodeacc; 
                data.namaacc  =  	 this.frmdata.namaacc; 
                data.consolacc  =  	 this.frmdata.consolacc; 
                data.consolaccname  =  	 this.frmdata.consolaccname; 
                await mapcoa.save(this.frmdata);
                toastr.success('Save Consolidation Mapping Account, successfully ');
                this.frmdata.kodeacc=''; 
                this.frmdata.namaacc=''; 
                // this.frmdata.consolacc=''; 
                // this.frmdata.consolaccInfo=''; 
                this.getData();
                this.isLoading=false;    
                } catch (error) {
                        this.isLoading=false;
                    console.log('error : ', error);
                    if (error.sql) {
                        toastr.error(error.sql,'ERROR MESSAGE',10000);
                    } else if (error.sqlMessage) {
                        toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                    } else if (error.message) {
                        toastr.error(error.message,'ERROR MESSAGE',10000);
                    } else {
                        toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                    }   
                    this.isLoading=false;            
                }

        }
    },
    exportxls: async function() {
        if (this.invalidFilter) {
            console.log('model obj : ',this.filter);
            toastr.error('Please fill the form correctly.');
       } else {
            this.isLoading=true;
            try {
                const response = await mapcoa.exportxls(this.frmdata);
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `tb_unit_${this.frmdata.company}.xlsx`);
                document.body.appendChild(link);
                link.click();
                // window.location.assign(url);

                this.isLoading=false;    
            } catch (error) {
                this.isLoading=false;            
                console.log('error : ', error);
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }        
            }
       }
    },    
    uploadmapping: async function() {
        this.onChangeMonth();
      if (this.invalidFrmdata) {
            console.log('validation : ', this.$v.frmdata);
            console.log('frmdata obj : ',this.frmdata);
            toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
        } else if (this.fileXlsx) {
            this.showUploadFrm = false;
            this.isLoading=true;
            try {
                this.tblData.items = await mapcoa.uploadmapping(this.fileXlsx,this.frmdata);
                this.tblData.total = this.tblData.items.length;  
                this.isLoading=false;   
                toastr.success(`Complete sucessfully`,'UPLOAD/IMPORT INVOICE',10000);
            } catch (error) {
                this.isLoading=false;
                this.showUploadFrm = true;
                console.log('error : ', error);
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }        
            }
        } else {
          toastr.warn('Please select one File XLSX that want to Upload ');
        }
    },       
    downloadtemplate: async function() {
            try {
                const response = await mapcoa.templatemapping();
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `EkosSystem-TB-upload-template.xlsx`);
                document.body.appendChild(link);
                link.click();
                this.isLoading=false;    
            } catch (error) {
                this.isLoading=false;            
                console.log('error : ', error);
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }        
            }

    },     
    closeFrm(){
          this.showForm=false;
    },
    close(){
          router.push("home");
    },

  }
};
</script>
